;(function (global) {
  function getLayoutFn() {
    const L = global.__dpoJqSliderLayout
    return L && typeof L.updateDpoJqSliderUI === 'function' ? L.updateDpoJqSliderUI : null
  }

  function hookDpoJqUiSliders() {
    try {
      const $ = global.jQuery || global.$
      if (!$ || typeof $.fn?.on !== 'function') return

      const layoutFn = getLayoutFn()
      if (!layoutFn) return

      const inputs = Array.from(document.querySelectorAll('input.dpo-slider-value'))
      inputs.forEach((input) => {
        if (!input || input.__vizDpoJqUiHooked || input.__vizShelvesJqUiHooked) return
        const control = input.closest('.control')
        const slider = control ? control.querySelector('.dpo-slider') : null
        if (!slider) return

        input.__vizDpoJqUiHooked = true
        const $slider = $(slider)
        try {
          $slider.off('slide.vizDpo stop.vizDpo')
        } catch (e) {}

        const syncUi = (value) => {
          try {
            const minAttr = Number(input.getAttribute('min'))
            const maxAttr = Number(input.getAttribute('max'))
            const min = Number.isFinite(minAttr) ? minAttr : 0
            const max = Number.isFinite(maxAttr) ? maxAttr : Math.max(min, 100)
            const fromArg = Number(value)
            const fromInput = Number(input.value)
            let raw = Number.isFinite(fromArg) ? fromArg : (Number.isFinite(fromInput) ? fromInput : NaN)
            if (!Number.isFinite(raw)) return
            const current = Math.max(min, Math.min(max, raw))
            input.value = String(current)
            layoutFn(control, input, min, max, Number.isFinite(current) ? current : min, {
              updateJqUi: true,
              defer: true,
            })
          } catch (e) {
            /* best-effort */
          }
        }

        const updateFromUi = (ui) => {
          try {
            const v = ui && ui.value != null ? String(ui.value) : String(input.value || '')
            input.value = v
            if (typeof global.__vizOnDpoSliderInput === 'function') {
              try {
                global.__vizOnDpoSliderInput(input, v)
              } catch (cbErr) {
                /* ignore */
              }
            }
            syncUi(v)
          } catch (e) {
            /* ignore */
          }
        }

        $slider.on('slide.vizDpo', function (_e, ui) {
          updateFromUi(ui)
        })
        $slider.on('stop.vizDpo', function (_e, ui) {
          updateFromUi(ui)
        })

        if (!input.__vizDpoJqUiValueListeners) {
          const syncFromInputValue = () => {
            try {
              syncUi(input.value)
            } catch (e) {
              /* ignore */
            }
          }
          input.addEventListener('input', syncFromInputValue)
          input.addEventListener('change', syncFromInputValue)
          input.__vizDpoJqUiValueListeners = true
        }

        try {
          syncUi(input.value)
        } catch (e) {}

        try {
          if (typeof ResizeObserver !== 'undefined' && !slider.__vizDpoRO && !slider.__vizShelvesRO) {
            const ro = new ResizeObserver(() => {
              try {
                syncUi(input.value)
              } catch (e) {}
            })
            ro.observe(slider)
            slider.__vizDpoRO = ro
          } else if (!slider.__vizDpoResizeHooked && !slider.__vizShelvesResizeHooked) {
            slider.__vizDpoResizeHooked = true
            global.addEventListener('resize', () => {
              try {
                syncUi(input.value)
              } catch (e) {}
            })
          }
        } catch (e) {}

        try {
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(() => {
              try {
                syncUi(input.value)
              } catch (e) {}
            })
            requestAnimationFrame(() => {
              try {
                syncUi(input.value)
              } catch (e) {}
            })
          } else {
            setTimeout(() => {
              try {
                syncUi(input.value)
              } catch (e) {}
            }, 0)
          }
        } catch (e) {}
      })
    } catch (e) {
      /* non-fatal */
    }
  }

  global.__vizHookDpoJqUiSliders = hookDpoJqUiSliders

  function initObservers() {
    hookDpoJqUiSliders()
    const root =
      document.querySelector('#itoris_dynamicproductoptions') ||
      document.querySelector('.dpo-container')
    if (!root || typeof MutationObserver === 'undefined') return
    try {
      if (root.__vizDpoSliderMo) return
      const mo = new MutationObserver(() => {
        hookDpoJqUiSliders()
      })
      mo.observe(root, { childList: true, subtree: true })
      root.__vizDpoSliderMo = mo
    } catch (e) {}
  }

  const kick = () => {
    initObservers()
    let n = 0
    const t = global.setInterval(() => {
      hookDpoJqUiSliders()
      n += 1
      if (n >= 12) global.clearInterval(t)
    }, 250)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick)
  } else {
    kick()
  }
})(window)
